"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemLink = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
require("@/components/common/icon/icon");
const icon_names_1 = require("@/components/common/icon/icon-names");
const menu_item_styles_1 = require("@/components/common/menu-item/menu-item.styles");
const menu_item_utils_1 = require("@/components/common/menu-item/menu-item.utils");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * 메뉴에서 다른 곳으로 이동하는 링크 항목. 기본은 새 창으로 여는 외부 링크다.
 * 지금 보고 있는 페이지를 가리키는 내비게이션 링크 목록은 menu가 아니라 list로 읽히게 두고, 링크가 aria-current를 갖는다.
 */
let MenuItemLink = class MenuItemLink extends (0, menu_item_utils_1.withMenuItemPresentation)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.href = '';
        this.target = '_blank';
    }
    render() {
        return (0, lit_1.html) `
      <a
        href=${(0, if_defined_js_1.ifDefined)(this.disabled ? undefined : this.href)}
        role="menuitem"
        aria-disabled=${(0, if_defined_js_1.ifDefined)(this.disabled ? 'true' : undefined)}
        target=${this.target || lit_1.nothing}
        rel=${this.target === '_blank' ? 'noopener noreferrer' : lit_1.nothing}
      >
        ${(0, menu_item_utils_1.renderMenuItemContent)(this, this.renderTrailing())}${this.renderNewTabNote()}
      </a>
    `;
    }
    /** 새 창으로 열린다는 사실이 아이콘(시각)으로만 전달되지 않도록 링크 이름에 덧붙인다. */
    renderNewTabNote() {
        if (this.target !== '_blank')
            return lit_1.nothing;
        return (0, lit_1.html) `
      <span>새 창에서 열림</span>
    `;
    }
    renderTrailing() {
        return (0, lit_1.html) `
      <slot name="trailing" slot="trailing">${this.renderDefaultTrailing()}</slot>
    `;
    }
    renderDefaultTrailing() {
        const name = this.target === '_blank' ? icon_names_1.ICON_NAMES.SHARE : icon_names_1.ICON_NAMES.FORWARD;
        return (0, lit_1.html) `
      <mm-icon name=${name} size="small"></mm-icon>
    `;
    }
};
MenuItemLink.styles = [
    shared_styles_1.resetStyles,
    menu_item_styles_1.menuItemStyles,
    (0, lit_1.css) `
      a > span {
        ${shared_styles_1.visuallyHiddenStyles};
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], MenuItemLink.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MenuItemLink.prototype, "href", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MenuItemLink.prototype, "target", void 0);
MenuItemLink = __decorate([
    (0, decorators_js_1.customElement)('mm-menu-item-link')
], MenuItemLink);
exports.MenuItemLink = MenuItemLink;
//# sourceMappingURL=data:application/json;base64,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